import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  allOrders: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  pendingOrders: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  confirmedOrders: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  rejectedOrders: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  singleOrderDetail: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  proposalListing: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  subscriptionListing: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  ivsDownloadListing: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  ivsOrderListing: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
  checkoutOrder: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
};

export const orderSlice = createSlice({
  name: 'orderListing',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAllOrdersListingLoading: (state, action) => {
      state.allOrders.loading = action.payload;
    },
    setAllOrdersListing: (state, action) => {
      state.allOrders.items = action.payload;
      state.allOrders.error = {
        isError: false,
        message: '',
      };
    },
    setAllOrdersListingError: (state, action) => {
      state.allOrders.items = {};
      state.allOrders.error = action.payload;
    },
    setPendingOrderListingLoading: (state, action) => {
      state.pendingOrders.loading = action.payload;
    },
    setPendingOrderListing: (state, action) => {
      state.pendingOrders.items = action.payload;
      state.pendingOrders.error = {
        isError: false,
        message: '',
      };
    },
    setPendingOrderListingError: (state, action) => {
      state.pendingOrders.items = {};
      state.pendingOrders.error = action.payload;
    },
    setConfirmedOrderListingLoading: (state, action) => {
      state.confirmedOrders.loading = action.payload;
    },
    setConfirmedOrderListing: (state, action) => {
      state.confirmedOrders.items = action.payload;
      state.confirmedOrders.error = {
        isError: false,
        message: '',
      };
    },
    setConfirmedOrderListingError: (state, action) => {
      state.confirmedOrders.items = {};
      state.confirmedOrders.error = action.payload;
    },
    setRejectedOrderListingLoading: (state, action) => {
      state.rejectedOrders.loading = action.payload;
    },
    setRejectedOrderListing: (state, action) => {
      state.rejectedOrders.items = action.payload;
      state.rejectedOrders.error = {
        isError: false,
        message: '',
      };
    },
    setRejectedOrderListingError: (state, action) => {
      state.rejectedOrders.items = {};
      state.rejectedOrders.error = action.payload;
    },
    setOrderDetailsLoading: (state, action) => {
      state.singleOrderDetail.loading = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.singleOrderDetail.items = action.payload;
      state.singleOrderDetail.error = {
        isError: false,
        message: '',
      };
    },
    setOrderDetailsError: (state, action) => {
      state.singleOrderDetail.items = {};
      state.singleOrderDetail.error = action.payload;
    },
    setProposalListingLoading: (state, action) => {
      state.proposalListing.loading = action.payload;
    },
    setProposalListing: (state, action) => {
      state.proposalListing.items = action.payload;
      state.proposalListing.error = {
        isError: false,
        message: '',
      };
    },
    setProposalListingError: (state, action) => {
      state.proposalListing.items = {};
      state.proposalListing.error = action.payload;
    },
    setSubscriptionListingLoading: (state, action) => {
      state.subscriptionListing.loading = action.payload;
    },
    setSubscriptionListing: (state, action) => {
      state.subscriptionListing.items = action.payload;
      state.subscriptionListing.error = {
        isError: false,
        message: '',
      };
    },
    setSubscriptionListingError: (state, action) => {
      state.subscriptionListing.items = {};
      state.subscriptionListing.error = action.payload;
    },
    setIvsDownloadListingLoading: (state, action) => {
      state.ivsDownloadListing.loading = action.payload;
    },
    setIvsDownloadListing: (state, action) => {
      state.ivsDownloadListing.items = action.payload;
      state.ivsDownloadListing.error = {
        isError: false,
        message: '',
      };
    },
    setIvsDownloadListingError: (state, action) => {
      state.ivsDownloadListing.items = {};
      state.ivsDownloadListing.error = action.payload;
    },
    setIvsOrderListingLoading: (state, action) => {
      state.ivsOrderListing.loading = action.payload;
    },
    setIvsOrderListing: (state, action) => {
      state.ivsOrderListing.items = action.payload;
      state.ivsOrderListing.error = {
        isError: false,
        message: '',
      };
    },
    setIvsOrderListingError: (state, action) => {
      state.ivsOrderListing.items = {};
      state.ivsOrderListing.error = action.payload;
    },
    setCheckoutOrderLoading: (state, action) => {
      state.checkoutOrder.loading = action.payload;
    },
    setCheckoutOrder: (state, action) => {
      state.checkoutOrder.items = action.payload;
      state.checkoutOrder.error = {
        isError: false,
        message: '',
      };
    },
    setCheckoutOrderError: (state, action) => {
      state.checkoutOrder.items = {};
      state.checkoutOrder.error = action.payload;
    },
  },
});

export default orderSlice.reducer;

// Action creators are generated for each case reducer function
export const {
  setLoading,
  setAllOrdersListing,
  setAllOrdersListingError,
  setPendingOrderListing,
  setPendingOrderListingError,
  setConfirmedOrderListing,
  setConfirmedOrderListingError,
  setRejectedOrderListing,
  setRejectedOrderListingError,
  setOrderDetails,
  setOrderDetailsError,
  setProposalListing,
  setProposalListingError,
  setSubscriptionListing,
  setSubscriptionListingError,
  setIvsDownloadListing,
  setIvsDownloadListingError,
  setIvsOrderListing,
  setIvsOrderListingError,
  setAllOrdersListingLoading,
  setConfirmedOrderListingLoading,
  setIvsDownloadListingLoading,
  setIvsOrderListingLoading,
  setOrderDetailsLoading,
  setPendingOrderListingLoading,
  setProposalListingLoading,
  setRejectedOrderListingLoading,
  setSubscriptionListingLoading,
  setCheckoutOrderLoading,
  setCheckoutOrder,
  setCheckoutOrderError,
} = orderSlice.actions;

export const orderListingItemsSelector = (state) => state.orderList;
